export { UsersContainer as default, UsersComponent } from './users'



// WEBPACK FOOTER //
// ./src/pages/admin/users/index.js